import React from 'react';

const FramontLogo = ({ className = "h-10 w-auto", color = "#FFD166" }) => {
  return (
    <img 
      src="/framont-logo.png" 
      alt="Framont" 
      className={className} 
    />
  );
};

export default FramontLogo;